export default __webpack_public_path__ + "static/media/grafico_03.12508459.png";